import { V2OrderSideType } from '@flipster/utils/types/base';

export function getSegmentPositionSide(side: V2OrderSideType): 'buy' | 'sell' {
  switch (side) {
    case 'Long':
      return 'buy';
    case 'Short':
      return 'sell';
    default:
      side satisfies never;
      throw Error('unreachable');
  }
}
